module.exports = __webpack_public_path__ + "static/killstress-placeholder-6a17ad4d8494e7e06064cb019ff8bbad.png";